export default __webpack_public_path__ + "static/media/logo-election2018.df50002f.svg";